import type { IProvider } from '@web3auth/base';
import { CHAIN_NAMESPACES } from '@web3auth/base';
import { EthereumPrivateKeyProvider } from '@web3auth/ethereum-provider';

const chainConfig = {
  chainId: '0x89',
  displayName: 'Polygon Mainnet',
  chainNamespace: CHAIN_NAMESPACES.EIP155,
  tickerName: 'MATIC',
  ticker: 'MATIC',
  decimals: 18,
  rpcTarget: 'https://rpc.ankr.com/polygon/01e68499d32f39afb838226c738d21f57518de3d60ca18aa6697bc8822aedb2f',
  blockExplorerUrl: 'https://polygonscan.com',
};

export const EvmPrivateKeyProvider = new EthereumPrivateKeyProvider({
  config: { chainConfig },
});

export const getEthereumAddress = async (initProvider: IProvider): Promise<{
  ethWalletAddress: string;
  ethPrivateKey: string;
}> => {
  const ethPrivateKey = await initProvider?.request({
    method: 'eth_private_key',
  }) as string;
  const ethAddresses = await initProvider?.request({ method: 'eth_accounts' }) as string;

  const ethWalletAddress = (ethAddresses as any)[0];

  return {
    ethWalletAddress,
    ethPrivateKey,
  };
};
